<template>
    <div class="modal-wrap ml20 mr20">
        <p class="text-bold tac mb10">以下任务没有待上传素材，无法继续操作，请剔除后继续。</p>
        <div class="form-wrap tac">
            <p v-for="item in list" :key="item.detail_id">{{item.detail_id}}/{{(item.name||[]).join(',')}}/{{item.finish_time}}</p>
        </div>
        <div class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">剔除</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TaskUploadingModal",
        props:{
            cbs:{
                type:Object,
            },
            list:Array,
        },
        data(){
            return {}
        },
        methods:{
            handleClose() {
                this.cbs.onClose();
            },
            handleSubmit() {
                this.cbs.onSubmit();
                this.handleClose();
            },
        },

    }
</script>

<style lang="scss" scoped>
    .form-wrap{
        max-height: 350px;
        overflow-y: auto;
    }
</style>
